/** Resolve relative attendance image paths from the backend origin (not /api). */
export function resolveAttendanceImageUrl(url: string | null | undefined): string {
  if (!url) return "";
  const trimmed = url.trim();
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://") || trimmed.startsWith("data:")) {
    return trimmed;
  }
  const base = (process.env.REACT_APP_API_BASE_URL || "")
    .replace(/\/+$/, "")
    .replace(/\/api$/i, "");
  if (!base) return trimmed;
  return `${base}${trimmed.startsWith("/") ? trimmed : `/${trimmed}`}`;
}
